namespace $.$$ {

	/** Приватный (шифрованный ленд) список диалогов пользователя. */
	export class $bog_gram_dialogs extends $giper_baza_dict.with({
		Dialogs: $giper_baza_list_str,
		/** Неотправленные инвайты вида "lord|dialog" — шлются, когда доедут права чужого inbox */
		Outbox: $giper_baza_list_str,
		/** Очередь заявок в группы: ссылка на ленд группы. Отдельно от Outbox —
		 * тот ждёт первого сообщения в диалоге, а заявку шлют до всякого
		 * доступа к переписке, и общая проверка её просто заперла бы */
		Asks: $giper_baza_list_str,
		/** Заявки, уже доехавшие до чужого лобби. Второй раз их не шлём:
		 * отклонённую заявку админ из лобби убирает, и повтор возвращал бы её
		 * туда снова. Запись держится тут, пока не выдадут права, — по ней же
		 * рисуется «ждём подтверждения» */
		Asked: $giper_baza_list_str,
		/** Группы, по заявкам в которые пришёл отказ. Держим их тут, а не в
		 * лобби: запись из лобби снимается сразу, а сказать о решении надо —
		 * иначе заявка просто исчезнет с экрана без объяснений. Повторный
		 * переход по ссылке эту отметку снимает: отказ не бан */
		Denied: $giper_baza_list_str,
		/** Убранные из своего списка диалоги — иначе повторный инвайт вернул бы их обратно */
		Hidden: $giper_baza_list_str,
		/** Собеседники, с которыми владелец согласился переписываться: их диалоги
		 * идут в общий список, а не в запросы. Ключ — lord человека, а не ссылка
		 * на диалог: согласие даётся один раз и на все его будущие диалоги */
		Accepted: $giper_baza_list_str,
		/** Ссылки на известные владельцу реестры пользователей */
		Registries: $giper_baza_list_str,
		/** Ленд избранного — заметок для себя. Ссылка личная, поэтому лежит тут, а не в открытом профиле */
		Saved_land: $giper_baza_atom_text,
		/** Все заведённые ленды заметок. Ссылка выше — одна, и в ней побеждает
		 * та запись, что легла позже: два устройства, заведя избранное каждое
		 * своё (список диалогов приезжает не мгновенно, и пустая ссылка на нём
		 * выглядит как «ленда ещё нет»), проигравшую ссылку потеряли бы вместе
		 * со всеми заметками. Список же сливается, а не перетирается —
		 * читаем изо всех лендов, пишем в тот, на который указывает ссылка */
		Saved_lands: $giper_baza_list_str,
		/** Спрятанные из основного списка диалоги: в отличие от Hidden, возвращаются одним кликом */
		Archived: $giper_baza_list_str,
		/** Подписи собеседников «как я его назвал», ключ — lord собеседника.
		 * Ленд приватный, поэтому подпись видна только владельцу */
		Notes: $giper_baza_dict_to( $bog_gram_note ),
	}) {}

}
